import React, { Component } from 'react';
import cx from 'classnames';
import { Field, reduxForm, change, submit } from 'redux-form';
import Select from 'components/common/Select';

import Input from 'components/common/InputForm';
import Checkbox from 'components/common/Checkbox';
import validate from './validate';

import s from './style';

const options = [
  { value: 'до 10', label: 'до 10' },
  { value: 'до 20', label: 'до 20' },
  { value: 'до 30', label: 'до 30' },
  { value: 'до 50', label: 'до 50' },
  { value: 'до 75', label: 'до 75' },
  { value: 'до 100', label: 'до 100' }
];

class RequestToConnect extends Component {
  checkbox = ({ input, text, meta: { touched, error } }) => (
    <div className={s.rules}>
      <Checkbox
        innerStyle={s.rulesCheckbox}
        text={text}
        checked={input.value}
        {...input}
      />
      {touched && error && <div className={s.error}>{error}</div> }
    </div>
    )

  select = (options) => (
    <Select
      {...options}
    />
  )

  submit = async (data) => {
    data.countUsers = data.countUsers.value;
    await this.props.onSubmit(data);
    this.props.setPopUp();
  }

  render() {
    return (
      <form className={s.root} onSubmit={this.props.handleSubmit(data => this.submit(data))}>
        <div className={s.head}>Заявка на подключение компании</div>
        <div className={s.fields}>
          <div className={s.basic}>
            <Field
              name="companyName"
              component={Input}
              label="Название компании"
              placeholder="Ави Инвест"
              className={s.input}
              required
            />
            <Field
              name="countUsers"
              component={this.select}
              label="Кол-во сотрудников"
              placeholder="Выберите..."
              className={s.input}
              options={options}
              required
            />
          </div>
          <div className={s.informationWrapper}>
            <div className={s.h}>Контактная информация</div>
            <div className={s.information}>
              <Field
                name="name"
                component={Input}
                label="Имя"
                placeholder="Евгений"
                className={cx(s.input, s.inputSpace)}
                required
              />
              <Field
                name="soname"
                component={Input}
                label="Фамилия"
                placeholder="Петров"
                className={cx(s.input, s.inputSpace)}
                required
              />
              <Field
                name="position"
                component={Input}
                label="Должность"
                placeholder="Специалист по продажам"
                className={s.input}
                required
              />
              <Field
                name="phone"
                component={Input}
                label="+7 (000) 000-00-00"
                placeholder="Телефон"
                className={s.input}
                required
              />
            </div>
          </div>
        </div>
        <div className={s.bottom}>
          <Field
            name="rules"
            component={this.checkbox}
            text={<span>Я согласен на обработку персональных данных</span>}
            required
          />
          <button type="submit" className={s.btn}>Отправить заявку</button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'RequestToConnect',
  validate
})(RequestToConnect);



// WEBPACK FOOTER //
// ./src/components/Payments/RequestToConnect/RequestToConnect.js